export default {
  getImageUpload: state => state.itens
}



// WEBPACK FOOTER //
// ./src/store/modules/image_upload/getters.js